import type { ContactType } from "@bbj-types/contact/enum";
import { useCallback } from "react";
import { axiosEnterprise } from "./axios";

type BaseContactBody<T extends ContactType> = {
  type: T;
} & (T extends ContactType.ENTERPRISE ? { enterpriseId: string } : { enterpriseId?: never });

type TDeleteContactBody = BaseContactBody<ContactType.STRUCTURE_PARTNER> | BaseContactBody<ContactType.ENTERPRISE>;

export const useDeleteContact = () => {
  const [state, execute, cancel] = axiosEnterprise<void, TDeleteContactBody, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (contactId: string, data: TDeleteContactBody) => {
      return execute({
        url: `/contacts/${contactId}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
